<template>
    <div class="columns">
        <div class="column">
            <div class="buttons">
                <button class="button" @click="goToPrev" :disabled="!hasPrevPage">
                    <span>{{ translate("admin_payments.previous_page") }}</span>
                    <span class="icon">
                        <i class="fas fa-chevron-left"></i>
                    </span>
                </button>
                <button class="button" @click="goToNext" :disabled="!hasNextPage">
                    <span>{{ translate("admin_payments.next_page") }}</span>
                    <span class="icon">
                        <i class="fas fa-chevron-right"></i>
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import history from "../Common/history";
    import { translate } from "../Common/translations";
    import { useRegisteredCompetitorsStore } from "./registeredCompetitorsStore";

    const store = useRegisteredCompetitorsStore();
    const historyInstance = history.getInstance(window);

    const hasNextPage = computed(() => store.hasNextPage);
    const hasPrevPage = computed(() => store.hasPrevPage);
    const offset = computed(() => store.offset);

    const goToPrev = () => {
        store.decreaseOffset();
        historyInstance.setQueryParam("offset", offset.value);
        return store.getRegisteredCompetitorsPage().catch(console.error);
    };

    const goToNext = () => {
        store.increaseOffset();
        historyInstance.setQueryParam("offset", offset.value);
        return store.getRegisteredCompetitorsPage().catch(console.error);
    };
</script>

<style scoped></style>
